import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { StatusCardProps as Props } from './types';
import { Typography } from '@mui/material';

export const StatusCard = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('StatusCard', className)}
      sx={SX.root}
    >
      <Typography variant="body3" color="success.700" fontWeight={700}>
        You’ve successfully canceled your downgrade.
      </Typography>
    </Styled.Wrapper>
  );
});

StatusCard.displayName = 'StatusCard';
